<template>
  <!-- Be sure to use this with a layout container that is full-width on mobile -->
  <div
    :class="[$props.noRoundedbottom ? 'rounded-t-lg' : 'rounded-lg', $props.noShadow ? '' : 'shadow', customClass ? customClass : 'bg-white']"
  >
    <div class="px-8 py-8 sm:p-6">
      <slot />
      <!-- Content goes here -->
    </div>
  </div>
</template>
<script>
export default {
  name: 'Card',
  props: {
    noRoundedbottom: {
      default: false,
      type: Boolean
    },
    noShadow: {
      default: false,
      type: Boolean
    },
    customClass: {
      default: '',
      type: String
    }
  },
  setup() {
    return {};
  }
};
</script>
